// extracted to have an easier tranition into the italian release
import * as Yup from 'yup'
import { TFunction } from 'i18next'

export const getSimpleContractChangeFormValidationSchema = (
  t: TFunction,
): Yup.ObjectSchema<{
  changes: any
  validFrom: string
}> => {
  return Yup.object().shape({
    changes: Yup.object().shape(
      {
        salary: Yup.number()
          .transform((value) => (isNaN(value) ? undefined : value))
          .test({
            name: 'salaryChange',
            // arrow functions cannot be used here because of different behaviour in this binding
            test: function () {
              const context: any = this.options.context
              const { salary, bonus, employeeLevel, nationalReferenceLevel, governmentJobTitle } = context.changes

              // default case at least one field needs to be filled out -> add the dropdown
              if (
                salary === undefined &&
                employeeLevel === undefined &&
                bonus === undefined &&
                nationalReferenceLevel === undefined &&
                governmentJobTitle === undefined
              ) {
                return this.createError({
                  message: t('formError.conditionalRequired', {
                    fieldNames: `${t('appraisalMeeting.contract.changes.form.salary')},
                ${t('appraisalMeeting.contract.employeeLevel')},
                ${t('appraisalMeeting.contract.bonus')},
                ${t('appraisalMeeting.contract.nationalReferenceLevel')}`,
                  }),
                  path: 'changes.salary',
                })
              }
              // TODO: DO WE HAVE TO EXTEND THIS PIECE OF CODE SO TO INCLUDE CURRENCY CONVERSION?
              return true
            },
          }),
        bonus: Yup.number()
          .transform((value) => (isNaN(value) ? undefined : value))
          .test({
            name: 'TargetBonusTest',
            test: function () {
              const context: any = this.options.context
              const { bonus, employeeLevel, nationalReferenceLevel } = context.changes
              const { salary } = context.changes

              if (salary === undefined && employeeLevel === undefined && bonus === undefined && nationalReferenceLevel === undefined) {
                return this.createError({
                  message: t('formError.conditionalRequired', {
                    fieldNames: `${t('appraisalMeeting.contract.changes.form.salary')},
                ${t('appraisalMeeting.contract.employeeLevel')},
                ${t('appraisalMeeting.contract.bonus')},
                ${t('appraisalMeeting.contract.nationalReferenceLevel')}`,
                  }),
                  path: 'changes.bonus',
                })
              }

              return true
            },
          }),

        employeeLevel: Yup.string()
          .transform((value) => (isNaN(value) ? undefined : value))
          .test({
            name: 'EmployeeLevelTest',
            test: function () {
              const context: any = this.options.context
              const { salary, bonus, employeeLevel, nationalReferenceLevel } = context.changes

              if (salary === undefined && employeeLevel === undefined && bonus === undefined && nationalReferenceLevel === undefined) {
                return this.createError({
                  message: t('formError.conditionalRequired', {
                    fieldNames: `${t('appraisalMeeting.contract.changes.form.salary')},
                ${t('appraisalMeeting.contract.employeeLevel')},
                ${t('appraisalMeeting.contract.bonus')},
                ${t('appraisalMeeting.contract.nationalReferenceLevel')}`,
                  }),
                  path: 'changes.employeeLevel',
                })
              }
              return true
            },
          }),

        nationalReferenceLevel: Yup.string()
          .transform((value) => (isNaN(value) ? undefined : value))
          .test({
            name: 'EmployeeLevelTest',
            test: function () {
              const context: any = this.options.context
              const { salary, bonus, employeeLevel, nationalReferenceLevel } = context.changes

              if (salary === undefined && employeeLevel === undefined && bonus === undefined && nationalReferenceLevel === undefined) {
                return this.createError({
                  message: t('formError.conditionalRequired', {
                    fieldNames: `${t('appraisalMeeting.contract.changes.form.salary')},
                ${t('appraisalMeeting.contract.employeeLevel')},
                ${t('appraisalMeeting.contract.bonus')},
                ${t('appraisalMeeting.contract.nationalReferenceLevel')}`,
                  }),
                  path: 'changes.nationalReferenceLevel',
                })
              }

              return true
            },
          }),
      },
      // the following list of fields is used in the noSoftEdges parameter that is barely documented
      // https://gitmemory.com/issue/jquense/yup/720/564591045
      // it is basically a hack to force a certain sorting of fields to avoid cyclical dependencies
      // it is unclear if it is needed here, it will remain and needs to be analyzed in a different ticket
      [
        ['bonus', 'salary'],
        ['employeeLevel', 'salary'],
        ['employeeLevel', 'bonus'],
      ],
    ),

    validFrom: Yup.string().required(t('formError.required', { fieldName: t(`appraisalMeeting.contract.changes.form.validFrom`) })),
  })
}
